module.exports = __webpack_public_path__ + "img/Oil.afc069de.svg";